import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

export type TChatDates = { checkin: string; checkout: string };

export interface IBuildChatSrcParams {
  gaLabel?: string;
  dates: TChatDates | null;
  defaultMessage: string | null;
}

export type TChatOffer = Pick<IDailyRentOfferForMobileSite, 'cianId' | 'dealType' | 'offerType'>;

export function buildChatSrc(offer: TChatOffer, { gaLabel, dates, defaultMessage }: IBuildChatSrcParams): string {
  const { cianId, dealType, offerType } = offer;

  return (
    `/dialogs/?hostType=frame&offerId=${cianId}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    '&pageType=Listing' +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    `${dates ? '&checkin=' + encodeURIComponent(dates.checkin) : ''}` +
    `${dates ? '&checkout=' + encodeURIComponent(dates.checkout) : ''}`
  );
}
